<template>
  <div class="footer disabled-print">
    <footer>Copyright &copy; 2026 All Rights Reserved</footer>
  </div>
</template>

<script>
export default {
  name: "HeaderNav",
  components: {},
  props: {
    msg: String,
  },
};
</script>
